import { zhCN } from '../core/i18n/zhCN';
import { useGameStore } from '../store/gameStore';
import { useSettingsStore } from '../store/settingsStore';

export function Hud() {
  const player = useGameStore((state) => state.game.player);
  const audio = useSettingsStore((state) => state.audio);
  const openSettings = useSettingsStore((state) => state.actions.openPanel);
  const soundEnabled = audio.musicVolume > 0 || audio.sfxVolume > 0;
  return (
    <header className="hud">
      <div>
        <span className="brand">{zhCN.app.title}</span>
        <span className="level">Lv.{player.level}</span>
      </div>
      <div className="resources">
        <span>
          ⭐ {player.xp}/{player.level * 100}
        </span>
        <span>🪙 {player.coins}</span>
        <button
          className="sound-settings-button"
          aria-label={zhCN.audio.open}
          onClick={openSettings}
        >
          {soundEnabled ? '🔊' : '🔇'}
        </button>
      </div>
    </header>
  );
}
